import { TSID_SUB_COOKIE } from 'config/cookie';
import { cookiesInstance } from './cookiesInstance';

export const set = (value: string) => cookiesInstance.set(TSID_SUB_COOKIE, value);

export const get = (): string | undefined => {
  return cookiesInstance.get(TSID_SUB_COOKIE);
};

export const remove = () => cookiesInstance.remove(TSID_SUB_COOKIE);
